"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { BarChart3, Grid3X3, LineChart, Search, TrendingUp } from "lucide-react";

const items = [
  { label: "Market", href: "/market", icon: BarChart3 },
  { label: "Flow", href: "/money-flow", icon: LineChart },
  { label: "Scanner", href: "/scanner", icon: Search },
  { label: "Strategy", href: "/strategies", icon: TrendingUp },
  {
    label: "More",
    href: "/more",
    icon: Grid3X3,
    aliases: [
      "/company-journey",
      "/portfolio",
      "/trade-journal",
      "/news",
      "/learning",
      "/calculator",
      "/daily-tracker",
      "/alerts",
    ],
  },
];

export default function MobileBottomNav() {
  const pathname = usePathname();

  function isActive(item: (typeof items)[number]) {
    if (!pathname) return false;
    const matchesHref = pathname === item.href || pathname.startsWith(`${item.href}/`);
    const matchesAlias = item.aliases?.some(
      (href) => pathname === href || pathname.startsWith(`${href}/`)
    );
    return matchesHref || Boolean(matchesAlias);
  }

  return (
    <nav className="mobileBottomNav" aria-label="Primary mobile navigation">
      <div className="mobileBottomNavInner">
        {items.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          return (
            <Link
              key={item.href}
              href={item.href}
              className={`mobileBottomNavItem${active ? " is-active" : ""}`}
              aria-current={active ? "page" : undefined}
              prefetch={false}
            >
              <Icon size={18} strokeWidth={2.2} aria-hidden="true" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
